import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditClusterReady} from '../redux/clusters'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


import '../static/css/clusterTable.css'
import {Cities,Employees} from '../../../common/DropDowns/index'
//import * as Helpers from '../../../common/helpers'

class AddEditCluster extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        clustersData:{},
        selectedKitchens:[],

        clustersName: "",
        cityId: "",
        managerId: "",
        code: "",

        clustersNameErrorText: false,
        clustersNameErrorData: '',

        cityIdErrorText: false,
        cityIdErrorData: '',

        managerIdErrorText: false,
        managerIdErrorData: '',

        codeErrorText: false,
        codeErrorData: '',

        subTitle: Constants.ADD_CLUSTER

    }

    this.isComponentStillMounted = true

    this.clustersNameComponent = null
    this.clustersNameSection = null

    this.cityIdComponent = null
    this.cityIdSection = null


    this.managerIdComponent = null
    this.managerIdSection = null

    this.codeComponent = null
    this.codeSection = null

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditClusterReady(false))

    if (this.props.clusters && this.props.clusters.clusterSelectedId && this.props.clusters.clusterSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_CLUSTER))
        this.setState({
            subTitle: "Edit Cluster",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_CLUSTER))
        this.setState({
            subTitle: "Add Cluster"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    if (this.props.clusters && this.props.clusters.clusterSelectedId && this.props.clusters.clusterSelectedId !== null) {
        this.getClusterById(this.props.clusters.clusterSelectedId)
    }else{

    this.props.dispatch(addEditClusterReady(true))
    }
}

componentDidMount() {

        this.clustersNameSection = ReactDOM.findDOMNode(this.refs.clustersNameSection)

        this.cityIdSection = ReactDOM.findDOMNode(this.refs.cityIdSection)

        this.managerIdSection = ReactDOM.findDOMNode(this.refs.managerIdSection)

        this.codeSection = ReactDOM.findDOMNode(this.refs.codeSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditClusterReady(false))
    let data = {}

    let clustersNameObject = this.mandateValidation("clustersName", Constants.FORM_INPUT)
    if (clustersNameObject.status) {
        data.name = this.clustersNameComponent.value
    } else {

         this.props.dispatch(addEditClusterReady(true))
        return
    }

    let cityIdObject = this.mandateValidation("cityId", Constants.FORM_SELECT)
    if (cityIdObject.status) {
        data.city_id = this.cityIdComponent.value
    } else {
        this.props.dispatch(addEditClusterReady(true))
        return
    }


    let managerIdObject = this.mandateValidation("managerId", Constants.FORM_SELECT)
    if (managerIdObject.status) {
        data.manager_id = this.managerIdComponent.value
    } else {
        this.props.dispatch(addEditClusterReady(true))
        return
    }

    data.code=this.codeComponent.value

    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editCluster(apiPayloadData,this.state.clustersData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditClusterReady(true))
                        this.props.history.push("/dashboard/clusters/list")
                    } else {

                        this.props.dispatch(addEditClusterReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditClusterReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addCluster(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditClusterReady(true))
                        this.props.history.push("/dashboard/clusters/list")
                    } else {

                        this.props.dispatch(addEditClusterReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditClusterReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}


getClusterById = (id) => {
    apiService.getClusterById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        clustersData: responseData.data ,
                        clustersName : responseData.data.name  ,
                        code : responseData.data.code ,
                        managerId : responseData.data.cluster_manager && responseData.data.cluster_manager.id ? responseData.data.cluster_manager.id : "",
                        cityId : responseData.data.city.id            
                    })

                    if (this.isComponentStillMounted) {
                        this.clustersNameComponent.value=responseData.data.name
                        this.codeComponent.value=responseData.data.code
                        this.cityIdComponent.value=responseData.data.city.id
                        this.managerIdComponent.value=responseData.data.cluster_manager && responseData.data.cluster_manager.id ? responseData.data.cluster_manager.id : ""
                    }

                    this.props.dispatch(addEditClusterReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditClusterReady(true))
        })
}




 cityChange = (data) => {
    this.cityIdComponent.value=data.value
        this.setState({
            cityId :data.value,
            cityIdErrorText: false,
            cityIdErrorData: ''
        })
        this.cityIdSection.className= this.cityIdSection.className.replace(" has-error", "")
    }



 employeeChange = (data) => {
    this.managerIdComponent.value=data.value
        this.setState({
            managerId :data.value,
            managerIdErrorText: false,
            managerIdErrorData: ''
        })
        this.managerIdSection.className= this.managerIdSection.className.replace(" has-error", "")
    }

    







    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.clustersNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Cluster Name" type="text" ref={el => this.clustersNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("clustersName")}} />
                                                        <span className="help-block"style={{display: this.state.clustersNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.clustersNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.codeSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Code </label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Cluster Code" type="text" ref={el => this.codeComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("code")}} />
                                                        <span className="help-block"style={{display: this.state.codeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.codeErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.cityIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City *</label>
                                                    <div className="col-sm-9" ref={el => this.cityIdComponent = el}>
                                                        
                                                         <Cities cityChange={this.cityChange} selectedValue={this.state.cityId} />

                                                        <span className="help-block"style={{display: this.state.cityIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.cityIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.managerIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Manager *</label>
                                                    <div className="col-sm-9" ref={el => this.managerIdComponent = el}>
                                                        
                                                         <Employees type="clm_list" employeeChange={this.employeeChange} selectedValue={this.state.managerId} />

                                                        <span className="help-block"style={{display: this.state.managerIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.managerIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        clusters: state.clusters,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditCluster))


// WEBPACK FOOTER //
// ./src/modules/Clusters/Components/AddEditCluster.js